import { useCurrentShop } from '../../../hooks/useCurrentShop'
import type { LaunchStrategyData } from '../LaunchStrategy.types'
import { guidesData, personasData } from '../data'
import { createGuideUrl } from '../utils/createGuideUrl'

export const useLaunchStrategyData = (): LaunchStrategyData => {
  const { currentShop } = useCurrentShop()
  const persona = currentShop?.persona || 'default'

  const data = persona in personasData ? personasData[persona] : personasData.default

  const categories = guidesData.map((category) => ({
    ...category,
    guides: category.guides.map((guide) => ({
      title: guide.title,
      url: createGuideUrl(guide.slug, data.guidesParameter),
    })),
  }))

  return {
    recommendation: data.recommendation,
    modal: {
      ...data.modal,
      categories,
    },
  }
}
